// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media screen and (min-width: 62.625em){.mobile_filters-module__display--okP34{display:none}}.mobile_filters-module__container--BIWiX{padding:16px;border-bottom:1px solid #c6ced5}\n", ""]);
// Exports
exports.locals = {
	"display": "mobile_filters-module__display--okP34",
	"container": "mobile_filters-module__container--BIWiX"
};
module.exports = exports;
